import { Link } from "react-router-dom";

import {
    HELP_EMAIL,
    PARTNER_EMAIL,
    PHONE_DIGITS,
    PHONE_DISPLAY,
} from "@/constants/links";

const PRODUCT_LINKS = [
    { href: "#what", label: "What C-ORE is" },
    { href: "#layers", label: "The three layers" },
    { href: "#pricing", label: "Pricing" },
];

const COMPANY_LINKS = [
    { href: "#problem", label: "The problem" },
    { href: "#contact", label: "Contact" },
];

export default function Footer() {
    const year = new Date().getFullYear();

    return (
        <footer className="footer" data-testid="v2-footer">
            <div className="container footer__grid">
                <div className="footer__brand">
                    <img
                        className="footer__logo"
                        src="/img/core-logo.png"
                        alt="C-ORE"
                        width="112"
                        height="24"
                    />
                    <p className="footer__tagline">
                        The management layer of a growing business.
                    </p>
                    <ul className="footer__contact">
                        <li>
                            <a
                                href={`mailto:${HELP_EMAIL}`}
                                data-testid="v2-footer-help-email"
                            >
                                {HELP_EMAIL}
                            </a>
                        </li>
                        <li>
                            <a
                                href={`tel:+${PHONE_DIGITS}`}
                                data-testid="v2-footer-phone"
                            >
                                {PHONE_DISPLAY}
                            </a>
                        </li>
                    </ul>
                </div>

                <div className="footer__col">
                    <h5 className="footer__heading">Product</h5>
                    <ul className="footer__links">
                        {PRODUCT_LINKS.map((l) => (
                            <li key={l.href}>
                                <a
                                    href={l.href}
                                    data-testid={`v2-footer-link-${l.href.slice(1)}`}
                                >
                                    {l.label}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="footer__col">
                    <h5 className="footer__heading">Company</h5>
                    <ul className="footer__links">
                        {COMPANY_LINKS.map((l) => (
                            <li key={l.href}>
                                <a
                                    href={l.href}
                                    data-testid={`v2-footer-link-${l.href.slice(1)}`}
                                >
                                    {l.label}
                                </a>
                            </li>
                        ))}
                        <li>
                            <a
                                href={`mailto:${PARTNER_EMAIL}`}
                                data-testid="v2-footer-ca-partners"
                            >
                                CA Partners
                            </a>
                        </li>
                    </ul>
                </div>

                <div className="footer__col">
                    <h5 className="footer__heading">Legal</h5>
                    <ul className="footer__links">
                        <li>
                            <Link
                                to="/privacy"
                                data-testid="v2-footer-privacy-link"
                            >
                                Privacy
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/terms"
                                data-testid="v2-footer-terms-link"
                            >
                                Terms
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/security"
                                data-testid="v2-footer-security-link"
                            >
                                Security
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>

            <div className="footer__bottom">
                <span className="footer__made" data-testid="v2-footer-made-in">
                    <span className="footer__made-dot" aria-hidden="true" />
                    Made in <strong>India</strong> &middot; Built for the
                    world.
                </span>
                <p
                    className="footer__legal-line"
                    data-testid="v2-footer-copyright"
                >
                    &copy; {year} Core Billion &mdash; India. All rights
                    reserved.
                    <br />
                    boardroom.c-ore.in &middot; {HELP_EMAIL} &middot;{" "}
                    {PHONE_DISPLAY}
                </p>
            </div>
        </footer>
    );
}
